import React from 'react'
import { Route, Switch } from 'react-router-dom'
import MainPage from 'containers/MainPage'
import CheckEmailPage from 'containers/CheckEmailPage'
import CreateAccountPage from 'containers/CreateAccountPage'
import ResetPasswordPage from 'containers/ResetPasswordPage'
import EstimatesStartPage from'containers/EstimatesStartPage'
import SignInPage from 'containers/SignInPage'
import { routePath } from 'routes'

const AuthRoutes = () => (
  <Switch>
    <Route path={routePath.CHECK_EMAIL} component={CheckEmailPage} />
    <Route path={routePath.RESET_PASSWORD} component={ResetPasswordPage} />
    <Route path={routePath.SIGN_IN} component={SignInPage} />
    <Route path={routePath.CREATE_ACCOUNT} component={CreateAccountPage} />
    <Route path={routePath.ESTIMATES_START_PAGE} component={EstimatesStartPage} />
    <Route path={routePath.AUTH} exact={true} component={MainPage} />
  </Switch>
)

export default AuthRoutes
